import FeatherIcon from 'feather-icons-react'
import { layoutTheme } from '../../theme/theme-constants'
import { useRecoilState } from 'recoil'
import { layoutThemeSelector } from '../../actions/LayoutMode.actions'
import useCookie from '../../hooks/useCookie'

const changeBodyAttribute = (attribute: any, value: any) => {
  if (document.body) document.body.setAttribute(attribute, value)
  return true
}

const LightDark = () => {
  const [cookieDarkMode, setCookieDarkMode] = useCookie('darkMode')
  const [layoutMode, setLayoutMode] = useRecoilState(layoutThemeSelector)

  const mode = layoutMode.layoutMode === layoutTheme['DARKMODE'] ? layoutTheme['LIGHTMODE'] : layoutTheme['DARKMODE']

  const onChangeLayoutMode = (value: any) => {
    if (value === 'light') {
      setLayoutMode({ layoutMode: 'light' })
      setCookieDarkMode('lightMode', 300)

      changeBodyAttribute('data-bs-theme', layoutTheme['LIGHTMODE'])
      changeBodyAttribute('data-topbar', layoutTheme['LIGHTMODE'])
      changeBodyAttribute('data-sidebar', layoutTheme['LIGHTMODE'])
    } else if (value === 'dark') {
      setLayoutMode({ layoutMode: 'dark' })
      setCookieDarkMode('darkMode', 300)

      changeBodyAttribute('data-bs-theme', layoutTheme['DARKMODE'])
      changeBodyAttribute('data-topbar', layoutTheme['DARKMODE'])
      changeBodyAttribute('data-sidebar', layoutTheme['DARKMODE'])
    }
  }

  return (
    <div className="dropdown d-sm-inline-block">
      <button onClick={() => onChangeLayoutMode(mode)} type="button" className="btn header-item">
        {layoutMode.layoutMode === layoutTheme['DARKMODE'] ? (
          <FeatherIcon icon="sun" className="icon-lg layout-mode-light" />
        ) : (
          <FeatherIcon icon="moon" className="icon-lg layout-mode-dark" />
        )}
      </button>
    </div>
  )
}

export default LightDark
